import { trigger, animate, style, group, animateChild, query, stagger, transition } from '@angular/animations';

export const routerTransition = trigger('routerTransition', [
    transition('* <=> *', [

    /* 1 */ query(':enter, :leave', style({ position: 'fixed', width: '100%' })
            , { optional: true }),
            query('.info', style({ opacity: 0 }), { optional: true }),
            query('.item-container', style({ opacity: 0 }), { optional: true }),
    /* 2 */ group([  // block executes in parallel
                query(':enter', [
                    style({ opacity: "0" }),
                    animate('125ms ease-out', style({ opacity: "1" }))
                ], { optional: true }),
                query(':leave', [
                    style({ opacity: "1" }),
                    animate('125ms ease-in', style({ opacity: "0" }))
                ], { optional: true })
            ]),
            query('.info',
            animate('125ms ease-out',
                style({opacity : 1})
            ),{optional:true}),
            /* 4 */ query(':enter .item-container', stagger(40, [
            style({ transform: 'translateY(50px)' }),
            animate('250ms ease-in-out', 
                style({ transform: 'translateY(0px)', opacity: 1 })),
            ]) , { optional : true } ) ,
    ])
])


// WEBPACK FOOTER //
// C:/Users/timva/Documents/Work/LatestDownload/src/app/router.animations.ts